import { IonAvatar, IonButton, IonCard, IonContent, IonIcon, IonItem, IonList, IonPopover } from '@ionic/react';
import { lockClosedOutline } from 'ionicons/icons';
import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { RouteNames } from '../../models/routes.model';
import { pinOutAsync } from '../../store/authSlice';

import { useAppDispatch, useAppSelector } from '../../store/hooks';
import AttendanceClockingCard from '../attendanceClockingCard/AttendanceClockingCard';
import LabourClockingCardHeader from '../labourClockingCard/labourClockingCardHeader/LabourClockingCardHeader';
import RequestQueueSpinner from '../requestQueueSpinner/RequestQueueSpinner';
import { IonChipWrapper } from './ProfileChip.styles';

interface IComponentProps {
  slot: string;
}

const ProfileChip: React.FC<IComponentProps> = ({ slot }) => {
  const popover = useRef<HTMLIonPopoverElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const history = useHistory();
  const { technician } = useAppSelector(state => state.auth);
  const { clockingQueue, techCommentQueue, vehicleAttachmentQueue } = useAppSelector(state => state.requestQueue);

  const dispatch = useAppDispatch();

  const handleSwapTechButtonClick = async () => {
    popover.current?.dismiss();
    await dispatch(pinOutAsync());
  };

  const handleSyncButtonClick = () => {
    popover.current?.dismiss();
    history.push({
      pathname: RouteNames.autoSync,
    });
  };

  return (
    <IonChipWrapper slot={slot} onClick={(e) => {
      popover.current!.event = e;
      setIsOpen(true);
    }}>
      <IonAvatar className="ion-no-margin avatar">
        <img src="assets/gravatar.png" alt="Profile Pic" />
      </IonAvatar>
      <RequestQueueSpinner />
      <IonPopover ref={popover} isOpen={isOpen} onDidDismiss={() => setIsOpen(false)} side="bottom" alignment="end">
        <IonContent color="lightest">
          <IonList>
            <IonItem lines="none">
              <IonAvatar className="ion-margin-end">
                <img src="assets/gravatar.png" alt="Profile Pic" />
              </IonAvatar>
              {technician?.displayName}
            </IonItem>
          </IonList>
          {(clockingQueue?.length || techCommentQueue?.length || vehicleAttachmentQueue?.length) ? <IonButton expand="full" onClick={() => handleSyncButtonClick()}>
            Synchronising
            <RequestQueueSpinner />
          </IonButton> : <></>}
          <AttendanceClockingCard simpleType />
          <IonCard className={`clocking-card simple`}>
            <LabourClockingCardHeader simpleType />
          </IonCard>
          <IonList>
            <IonItem lines="none" button onClick={() => handleSwapTechButtonClick()}>
              Swap Technician <IonIcon slot="end" icon={lockClosedOutline}></IonIcon>
            </IonItem>
          </IonList>

        </IonContent>
      </IonPopover>
    </IonChipWrapper>
  );
};

export default ProfileChip;
